import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { NavController, NavParams, ModalController, LoadingController, Platform, ToastController, AlertController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { TeeTimeBookingPlayer, NewGameInfo, PlayerList, PlayerInfo, AddressData, PlayerHomeInfo, UserAddress } from 'src/data/mygolf.data';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { FriendService } from 'src/providers/friend-service/friend-service';
import { PlayerService } from 'src/providers/player-service/player-service';
import { PlayerHomeDataService } from 'src/redux/player-home';
import { NewContactPage } from '../../new-contact/new-contact.page';
import { Country } from '../../sign-up/country-location';
import { filter, map, take } from 'rxjs/operators';

export interface NonMg2uPlayer {
  playerName: string;
  email: string;
  gender: string;
}

@Component({
  selector: 'app-user-manage-address',
  templateUrl: './user-manage-address.page.html',
  styleUrls: ['./user-manage-address.page.scss'],
})

export class UserManageAddressPage {
  listMode: string = 'friends';
  openedModal: boolean = false;
  playersToExclude: Array<TeeTimeBookingPlayer> = [];
  gameInfo: NewGameInfo;
  listFriends: PlayerList;

  friends: Array<PlayerInfo> = [];
  players: Array<PlayerInfo> = [];
  searchQuery: string = "";
  searchPlayers: string = "";

  availablePlayers: Array<PlayerInfo> = [];
  nonMg2uPlayer: NonMg2uPlayer;
  playerAddressForm: FormGroup;
  address1: AbstractControl;
  address2: AbstractControl;
  city: AbstractControl;
  postcode: AbstractControl;
  state: AbstractControl;
  phone1: AbstractControl;
  phone2: AbstractControl;
  playerContact: AbstractControl;
  // country

  _address1: string;
  _address2: string;
  _city: string;
  _postCode: string;
  _state: string;
  _phone1: string;
  _phone2: string;
  _playerContact: string;

  _address: AddressData;

  isCovid: boolean = true;

  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;

  currentPlayerId: number;

  player: TeeTimeBookingPlayer;
  playerContactA: string;
  @ViewChild('myInput') myInput: ElementRef;

  newPlayer: boolean = false;
  public countryList: Array<Country>;
  countryId: string;

  userAddressData: UserAddress;
  setAddressDefault: boolean;
  appFooterHide: boolean = true;
  userId: number;
  mode: string;
  addressName: string;
  fromProfile: boolean = false;
  constructor(private nav: NavController,
    private navParams: NavParams,
    private modalCtl: ModalController,
    private loadCtl: LoadingController,
    private platform: Platform,
    private keyboard: Keyboard,
    private toastCtl: ToastController,
    private friendService: FriendService,
    private playerService: PlayerService,
    // private modalCtl: ViewController,
    private fb: FormBuilder,
    private alertCtrl: AlertController,
    private playerHomeService: PlayerHomeDataService,
    private flightService: ClubFlightService) {
    this.openedModal = navParams.get("openedModal");
    let exclusion = navParams.get("playersToExclude");
    this.gameInfo = navParams.get("gameInfo");
    this.player = navParams.get("player");
    this.userAddressData = navParams.get("userAddressData");
    this.userId = navParams.get("userId");
    this.mode = navParams.get("mode");
    this.fromProfile = navParams.get("fromProfile");

    if (exclusion) {
      this.playersToExclude.push(...exclusion);
    }

    this.listFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      players: new Array<PlayerInfo>()
    };
    // if (this.gameInfo && this.gameInfo.availablePlayers && this.gameInfo.availablePlayers.length) {
    //     this.listFriends.players = this.gameInfo.availablePlayers.filter((p: PlayerInfo) => {
    //         let found = this.playersToExclude.filter(pl => {
    //             return pl.player.id === p.playerId;
    //         });
    //         return found.length === 0;
    //     });
    // }

    this.playerAddressForm = this.fb.group({
      address1: new FormControl('', [<any>Validators.required, <any>Validators.maxLength(50)]),
      address2: new FormControl('', [<any>Validators.required, <any>Validators.maxLength(50)]),
      city: new FormControl('', [<any>Validators.required, <any>Validators.maxLength(50)]),
      postcode: new FormControl('', [<any>Validators.required, <any>Validators.maxLength(50)]),
      state: new FormControl('', [<any>Validators.required, <any>Validators.maxLength(50)]),
      phone1: new FormControl('', [<any>Validators.required, Validators.minLength(7), <any>Validators.maxLength(50)]),
      phone2: new FormControl('', [<any>Validators.required, Validators.minLength(7), <any>Validators.maxLength(50)]),
      playerContact: new FormControl('', [<any>Validators.required, <any>Validators.maxLength(50)]),

    })

    this.address1 = this.playerAddressForm.controls["address1"];
    this.address2 = this.playerAddressForm.controls["address2"];
    this.city = this.playerAddressForm.controls["city"];
    this.postcode = this.playerAddressForm.controls["postcode"];
    this.state = this.playerAddressForm.controls["state"];
    this.phone1 = this.playerAddressForm.controls["phone1"];
    this.phone2 = this.playerAddressForm.controls["phone2"];
    this.playerContact = this.playerAddressForm.controls["playerContact"];

    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
    this.player$ = this.playerHomeInfo$
      .pipe(filter(Boolean))
      .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));

    this._address = {
      address1: '',
      address2: '',
      city: '',
      postCode: '',
      state: '',
      phone1: '',
      phone2: '',
      countryData: {
        id: 'MYS'
      }
    }

    let _player = this.player;
    if (_player && _player.email) this._address.email;
    if (this.userAddressData) {
      this._address = this.userAddressData.address;
      this.setAddressDefault = this.userAddressData.defaultAddress;
      if (!this._address.countryData) this._address.countryData = {};
      this.addressName = this.userAddressData.name;
    }


    // if(this._address) {
    //     // this._address1 = _address.address1;
    //     // this._address2 = _address.address2;
    //     // this._city = _address.city;
    //     // this._postCode = _address.postCode;
    //     // this._state = _address.state;
    //     // this._phone1 = _address.phone1;
    //     // this._phone2 = _address.phone2;
    //     // this._playerContact = '';
    //     // this.playerAddressForm.setValue({
    //     //     address1: _address.address1,
    //     //     address2: _address.address2,
    //     //     city: _address.city,
    //     //     postcode: _address.postCode,
    //     //     state: _address.state,
    //     //     phone1: _address.phone1,
    //     //     phone2: _address.phone2,
    //     //     playerContact: ''
    //     // })
    //     // this.playerAddressForm.get('address1').setValue()
    //     // this.playerAddressForm.address1.setValue(_address.address1);
    //     // this.address2.setValue(_address.address2);
    //     // this.city.setValue(_address.city);
    //     // this.postcode.setValue(_address.postCode);
    // } else {
    //     this.playerContactA = this.player.playerContact;
    // }
    this.callback = this.navParams.get("callback")


  }
  callback;

  resize() {
    this.myInput.nativeElement.style.height = this.myInput.nativeElement.scrollHeight + 'px';
  }

  ionViewDidLoad() {
    this.getCountry();

    // if (!this.listFriends.players.length)
    //     this._refreshValues();
    // else {
    //     this._filterOnSearch();
    // }

  }

  getCountry() {
    this.playerService.getCountryList()
      .subscribe((data: Array<Country>) => {

        this.countryList = data;

      });
  }

  ionViewWillLeave() {

    if (this.platform.is('ios') || this.platform.is('capacitor'))
      this.keyboard.hide();
  }

  onSearchInput() {
    this._filterOnSearch();
  }

  onSearchPlayers() {
    if (!this.searchPlayers)
      this.players = [];
    else
      this.playerService.searchPlayers(this.searchPlayers, true, 1)
        .subscribe((playerList: PlayerList) => {
          if (playerList && playerList.players) {
            this.players = playerList.players.filter(p => {
              let excluded = this.playersToExclude.find((pe => {
                return pe.player.id === p.playerId;
              }));
              return !excluded;
            });
          }
        });
  }

  friendSelected(item: PlayerInfo) {
    if (this.isCovid) {
      this._additionalForm(item);
    } else {
      this.modalCtl.dismiss(item);
    }
  }

  getImage(item: PlayerInfo) {
    if (item.thumbnail)
      return item.thumbnail;
    else if (item.photoUrl)
      return item.photoUrl;
    else
      return "img/default_user.png";
  }

  private async _refreshValues() {
    let busy = await this.loadCtl.create({
      message: "Please wait...",
      duration: 5000,
    });
    busy.present().then(() => {
      this.friendService.searchFriends("", true)
        .subscribe((friendRequests: PlayerList) => {
          busy.dismiss().then(() => {
            this.listFriends.players = friendRequests.players.filter(p => {
              let found = this.playersToExclude.filter(pl => {
                if (pl.player)
                  return pl.player.id === p.playerId;
              });
              return found.length === 0;
            });
            // this.gameInfo.
            this.availablePlayers = this.listFriends.players;
            // this._filterOnSearch();
            this.friends = this.listFriends.players;
          });

        }, (error) => {
          busy.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(error, "Error getting friend list");
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
          })
        });
    });

  }

  private _filterOnSearch() {
    if (!this.searchQuery)
      this.friends = this.listFriends.players;
    else {
      this.friends = this.listFriends.players.filter((p: PlayerInfo) => {
        let name = p.playerName;
        if (name && name.indexOf(this.searchQuery) >= 0)
          return true;
        else return false;
      })
    }
  }

  async newContact() {
    let newContactModal = await this.modalCtl.create({
      component: NewContactPage,
      componentProps: {
        openedAsDialog: true
      }
    });
    newContactModal.onDidDismiss().then((data: any) => {
      //Check whether the club info is passed
      if (data) {
        this.playerSelected(null, data);
      }
    });
    newContactModal.present();
  }

  playerSelected(event, item: PlayerInfo) {

    if (this.openedModal) {
      this.modalCtl.dismiss(item);
    }
  }

  close() {
    this.modalCtl.dismiss({
      save: false
    });
  }

  saveUserAddress() {

  }
  updateAddress() {

    if (this.mode === "newAddress" && (this.addressName.length === 0 || !this.addressName)) {
      MessageDisplayUtil.showMessageToast("Please enter address name", this.platform, this.toastCtl, 5000, "bottom");
      return false;
    } else if (!this._address.address1 || !this._address.city || !this._address.state || !this._address.postCode || !this._address.phone1) {
      MessageDisplayUtil.showMessageToast("Please enter all mandatory fields", this.platform, this.toastCtl, 5000, "bottom");
      return false;
    }
    // this._address.address1.length === 0 || this._address.city.length === 0 || this._address.state.length === 0
    //     || this._address.postCode.length === 0 || this._address.phone1.length === 0
    //     || 

    let _addressName = this.mode === "editAddress" ? this.userAddressData.name : this.addressName;
    let _address = this._address;
    _address['postalCode'] = this._address.postCode;
    let _setDefault = this.setAddressDefault;
    let _userId = this.userId;
    let _addressData = this.userAddressData;
    let _phone = this._address.phone1 + ',' + this._address.phone2;
    let _params = {
      phoneNumbers: _phone,
      country: this._address.countryData.id
    }
    _address = { ..._address, ...(_params as Partial<AddressData>) }



    this.flightService.userProfileUpdateAddress(_userId, _addressData, _addressName, _address, _setDefault)
      .subscribe((data) => {

        if (data) {
          if (data.userAddresses && data.userAddresses.length === 1 && !this.setAddressDefault) {
            this._setDefaultAddress(_userId, data.userAddresses[0])
          }
          MessageDisplayUtil.showMessageToast("Successfully updated address", this.platform, this.toastCtl, 5000, "bottom");

          if (this.fromProfile)
            this.callback({
              mode: this.mode,
              userAddressData: _addressData,
              status: 'success',
              message: 'Succesfully Updated Address'
            })
            // .then(() => {
            //   this.nav.pop();
            // });
          else if (!this.fromProfile) {
            this.modalCtl.dismiss({
              mode: this.mode,
              userAddressData: _addressData,
              status: 'success',
              message: 'Succesfully Updated Address'
            })
          }
        }
      }, (error) => {
        let _error;
        if (error) _error = error;
        MessageDisplayUtil.showMessageToast(error.errorMessage, this.platform, this.toastCtl, 5000, "bottom");

      })
    /*** callback function usage for passing opened nav page
     * 
        let param = {
            save: true,
            userAddressData: this._address,
            setDefaultAddress: this.setAddressDefault,
            mode: "editAddress"
        }
        this.callback(param).then(()=>{
            this.nav.pop();
         });
     */


    // this.modalCtl.dismiss({
    //     save: true,
    //     player: this.player,
    //     newPlayer: this.newPlayer,
    //     userAddressData: this._address,
    //     setDefaultAddress: this.setAddressDefault,
    //     playerContact: this.playerContactA,
    //     mode: "editAddress"
    // })
  }

  addPlayer() {
    if (this.isCovid) {
      this._additionalForm();
    } else {
      this.modalCtl.dismiss({
        newPlayer: true,
        playerDetails: this.playerAddressForm,
        // playerContact: playerContact

      });
    }
  }

  addMeself() {

    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      if (this.isCovid) {
        this._additionalForm(player);
      } else {
        this.modalCtl.dismiss(player);
      }
      // this.modalCtl.dismiss(player)
    });

  }

  async _additionalForm(item?: PlayerInfo) {
    let _isNewPlayer = (item) ? false : true;

    // <h3 style="color:red">COVID-19 Important Notice</h3>
    let _message = `<img item-left src="assets/img/booking-item-covid.svg" style="float:left;width: 4em;margin: 0.5em;" />
      
      <h4 item-right style="color:red;white-space: normal;">MGA recommends that all players should include their
          addresses for contact tracing</h4>`;
    let alert = await this.alertCtrl.create({
      header: 'COVID-19 Important Notice',
      // subTitle: 'Selected date is '+ _date,
      message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
      // buttons: ['Close']
      inputs: [
        {
          name: 'playerContact',
          placeholder: 'Enter address'
        }
      ],
      buttons: [{
        text: 'Proceed',
        // role: 'cancel',
        handler: (playerContact) => {

          this.modalCtl.dismiss({
            item: item,
            isCovid: true,
            newPlayer: _isNewPlayer,
            playerDetails: this.playerAddressForm.value,
            playerContact: playerContact

          });
          // this.nav.push(BookingHomePage, {
          //     fromBookNow: true
          // })

        }
      }
      ]
    });
    alert.present();


    // let newContactModal = this.modalCtl.create(NewContactPage, {
    //     openedAsDialog: true
    // });
    // newContactModal.onDidDismiss((data: PlayerInfo) => {
    //     //Check whether the club info is passed
    //     if (data) {
    //         this.playerSelected(null, data);
    //     }
    // });
    // newContactModal.present();


  }

  getPlayerDetails(attribute: string) {
    switch (attribute) {
      case 'name':
        // this.player.player?this.player.player.playerName:this.player.playerName
        return this.player.playerName ? this.player.playerName : '';
      case 'address1':
        return
      case 'address2':
        return;
      case 'city':
        return;
    }
  }


  _setDefaultAddress(userId, addressData) {
    let _userId = userId;
    let data = addressData.name;
    this.flightService.userProfileSetDefaultAddress(_userId, data)
      .subscribe((data) => {

        //   if(data) {
        //     //   MessageDisplayUtil.showMessageToast('Successfully set '+data.name+' as default address',
        //     //   this.platform, this.toastCtl,3000, 'bottom');
        //   }
      }, (error) => {
        MessageDisplayUtil.showErrorToast('Failed to set ' + data + ' as default address',
          this.platform, this.toastCtl, 3000, 'bottom');
      });

  }
}
